// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qi9_","largestCol":"styles_largestCol__3Ir2X","smallestCol":"styles_smallestCol__26o7U"};